"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
// Haptik Phrases is a string management API to centralize all the strings/texts
var HaptikPhrases_1 = __importDefault(require("@haptik/helpers/build/esm/HaptikPhrases"));
/**
 * How to set a phrase?
 * HaptikPhrases.setPhrase('sign in')
 *
 * How to set value with plural and verb string?
 * HaptikPhrases.setPhrase("CONNECT", "connect", {
 *   plural: "s",
 *   verb: "ing"
 * })
 *
 * How to use?
 * HaptikPhrases.getPhrase('SIGN_IN.CAPITALIZE')
 * HaptikPhrases.getPhrase('CONNECT.PLURAL.UPPERCASE')
 *
 * Forms Supported - Capitalize, Uppercase, Lowercase, Hyphenated and
 * Default which is passed in second argument of setPhrase
 *
 * For More Info Visit Platform Helpers (/?path=/story/haptik-phrases--usage)
 */
var BotBuilderConstants = HaptikPhrases_1["default"].setPhrase('iva')
    .setPhrase('SKILL', 'skill', { plural: 's' })
    .setPhrase('SKILL_SET', 'skill set', { plural: 's' })
    .setPhrase('bot')
    .setPhrase('USER_MESSAGE', 'user message', { plural: 's' })
    .setPhrase('BOT_RESPONSE', 'bot response', { plural: 's' })
    .setPhrase('CONNECTION', 'connection', { plural: 's' })
    .setPhrase('END_OF_QUERY', 'End of Query')
    .setPhrase('context clear')
    .setPhrase('smart')
    .setPhrase('STEP', 'step', { plural: 's' })
    .setPhrase('graph')
    .setPhrase('INTEGRATION', 'integration', { plural: 's' })
    .setPhrase('TRAIN', 'train', { verb: 'ing' })
    .setPhrase('entity')
    .setPhrase('entities')
    .setPhrase('FAQ', 'faq', { plural: 's' })
    .setPhrase('SMALL_TALK', 'small talk', { plural: 's' })
    .setPhrase('BREAK_MESSAGE', 'break message', { plural: 's' })
    .setPhrase('PUBLISH', 'publish', { verb: 'ing' })
    .setPhrase('transfer')
    .setPhrase('preview')
    .setPhrase('share')
    .setPhrase('quick reply')
    .setPhrase('quick replies')
    .setPhrase('language')
    .setPhrase('SUGGESTION', 'suggestion', { plural: 's' })
    .setPhrase('environment')
    .setPhrase('staging')
    .setPhrase('production')
    .setPhrase('general')
    .setPhrase('domain')
    .setPhrase('independent')
    .setPhrase('negative')
    .setPhrase('static')
    .setPhrase('code')
    .setPhrase('output')
    .setPhrase('start')
    .setPhrase('end')
    .setPhrase('VOICE_RESPONSE', 'voice response', { plural: 's' })
    .setPhrase('MENU_OPTION', 'menu option', { plural: 's' });
exports["default"] = BotBuilderConstants;
